import config from '../config';
import { ActionTypes as actions, PracticeActions, ConsultationsActions, UserActions } from '../actions';
import { History as history, Routes as routes } from '../navigation';
import { NotificationsUtils } from '../utils';
import { toast } from 'react-toastify';
import io from 'socket.io-client';
import axios from 'axios';

const subscribeToNotificationsSocket = (user_id) => {
  return (dispatch, getState) => {

    if (!getState().notifications.notificationsSocketSet) {

      let socket = io(config.NOTIF_URL, { path: '/notifications', query: `notification=${user_id}` });

      socket.on('new_consultation_created',       (notification) => { dispatch(addNewNotificationToAll(notification, user_id)) });
      socket.on('consultation_resolved',          (notification) => { dispatch(addNewNotificationToAll(notification, user_id)) });
      socket.on('added_to_consultation',          (notification) => { dispatch(addNewNotificationToAll(notification, user_id)) });
      socket.on('new_practice_join_request',      (notification) => { dispatch(addNewNotificationToAll(notification, user_id)) });
      socket.on('practice_join_request_approved', (notification) => { dispatch(addNewNotificationToAll(notification, user_id)) });
      socket.on('new_unassigned_client',          (notification) => { dispatch(addNewNotificationToAll(notification, user_id)) });
      socket.on('client_assigned',                (notification) => { dispatch(addNewNotificationToAll(notification, user_id)) });
      socket.on('new_front_desk_task',            (notification) => { dispatch(addNewNotificationToAll(notification, user_id)) });
      socket.on('front_desk_task_completed',      (notification) => { dispatch(addNewNotificationToAll(notification, user_id)) });
      socket.on('consultation_new_message',       (notification) => { dispatch(addNewNotificationToAll(notification, user_id)) });
      socket.on('new_client_connected',           (notification) => { dispatch(addNewNotificationToAll(notification, user_id)) });
      socket.on('video_call_ended',               (notification) => { dispatch(showBrowserNotification(notification, user_id)) });
      socket.on('new_update_appointment',         (notification) => { dispatch(showBrowserNotification(notification, user_id)) });
      socket.on('upcoming_appointment',           (notification) => { dispatch(showBrowserNotification(notification, user_id)) });

      dispatch({ type: actions.NOTIFICATIONS_UPDATE_CONSULTATIONS_SOCKET, payload: true });
    }

  }
}

const fetchNotificationRelatedData = (notification) => {
  return (dispatch, getState) => {

    const state        = getState();
    const token        = state && state.user && state.user.auth && state.user.auth.token   ? state.user.auth.token   : '';
    const user_id      = state && state.user && state.user.auth && state.user.auth.user_id ? state.user.auth.user_id : '';
    const practice     = getState().context.selectedPractice;
    const role         = getState().context.selectedRole;
    const isManagement = role === 'practice_owner' || role === 'practice_manager' || role === 'admin';
    const noManagement = role === 'vet' || role === 'tech' || role === 'behaviorist';

    if (!user_id || !token) {
      return;
    }

    const notificationType = notification && notification.type ? notification.type : '';
    switch (notificationType) {
      case 'new_front_desk_task':
        dispatch(PracticeActions.getFrontDeskUserTasks(token))
        break;
      case 'front_desk_task_completed':

        break;
      case 'consultation_resolved':
        dispatch(ConsultationsActions.getRefreshedConsultations());
        break;
      case 'added_to_consultation':
        dispatch(ConsultationsActions.getRefreshedConsultations());
        break;
      case 'new_consultation_created':
        dispatch(ConsultationsActions.getRefreshedConsultations());
        break;
      case 'consultation_new_message':
        const consultation_id = notification.data && notification.data.consultation_id ? notification.data.consultation_id : '';
        if (consultation_id) {
          dispatch(ConsultationsActions.getConsultationInfo(token, consultation_id));
        }
        break;
      case 'new_practice_join_request':
        if (isManagement) {
          dispatch(PracticeActions.getPracticeJoinRequests(token, practice));
        }
        break;
      case 'practice_join_request_approved':
          dispatch(UserActions.getUserRoles(token, user_id));
          dispatch(UserActions.getUserPracticeLocations(token, user_id));
        break;
      case 'new_unassigned_client':
        if (isManagement) {
          dispatch(PracticeActions.getPracticeClients(token, practice));
        }
        break;
      case 'client_assigned':

        break;
      default:

    }

  }
}

const getUserUnreadNotifications = (token) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/user/notifications`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      const notifications = data.notifications || [];
      if (data.success) {
        const sortedNotificationDicts = NotificationsUtils.getSortedNotificationsObject(notifications);
        dispatch({ type: actions.NOTIFICATIONS_UPDATE_DICT,      payload: sortedNotificationDicts.dict });
        dispatch({ type: actions.NOTIFICATIONS_UPDATE_TYPE_DICT, payload: sortedNotificationDicts.typeDict });
        dispatch({ type: actions.NOTIFICATIONS_UPDATE_CONSULTATIONS_DICT, payload: sortedNotificationDicts.consultDict });
      }
    }).catch((error) => { console.log(error) });

  }
}

const markNotificationAsSeen = (token, notification_id) => {
  return dispatch => {

    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    const requestToExistingPracticeURL = `${config.BASE_URL}/api/user/notifications/seen/${notification_id}`;

    axios.post(requestToExistingPracticeURL, JSON.stringify({}), requestConfig).then((response) => {
      const data = response.data;
      if (data.success) {
        dispatch(getUserUnreadNotifications(token))
      }
    }).catch((error) => { console.log(error) });

  }
}

const addNewNotificationToAll = (notification, user_id) => {
  return (dispatch, getState) => {

    const state = getState();
    const notificationsDict = state.notifications && state.notifications.notificationsDict ? state.notifications.notificationsDict : {};
    const notificationsTypeDict = state.notifications && state.notifications.notificationsTypeDict ? state.notifications.notificationsTypeDict : {};
    const notificationsConsultDict = state.notifications && state.notifications.notificationsConsultationsDict ? state.notifications.notificationsConsultationsDict : {};

    const updatedNotificationDicts = NotificationsUtils.addNotificationToAll(notification, notificationsDict, notificationsTypeDict, notificationsConsultDict);
    dispatch({ type: actions.NOTIFICATIONS_UPDATE_DICT,      payload: updatedNotificationDicts.dict });
    dispatch({ type: actions.NOTIFICATIONS_UPDATE_TYPE_DICT, payload: updatedNotificationDicts.typeDict });
    dispatch({ type: actions.NOTIFICATIONS_UPDATE_CONSULTATIONS_DICT, payload: updatedNotificationDicts.consultDict });
    dispatch(showBrowserNotification(notification, user_id));
    dispatch(fetchNotificationRelatedData(notification));
  }
}

const markConsultationNotificationsRead = (token, consultation_id) => {
  return (dispatch, getState) => {

    const state = getState();
    const notificationsDict = state.notifications && state.notifications.notificationsDict ? state.notifications.notificationsDict : {};
    const consultationNotifications = NotificationsUtils.getNotificationsForConsultation(consultation_id, notificationsDict);

    consultationNotifications.forEach((notification) => {
      const notification_id = notification._id;
      if (notification_id) {
        dispatch(markNotificationAsSeen(token, notification_id));
      }
    });

  }
}

const showBrowserNotification = (notif, user_id) => {
  return (dispatch, getState) => {

    if (notif.sender === user_id) {
      return;
    }

    const title = notif && notif.title ? notif.title : 'TeleTails';
    const body  = notif && notif.body  ? notif.body  : 'New Notification';

    if (Notification.permission === 'granted') {
      new Notification(title, { body });
    }

  }
}

const requestBrowserNotificationPermissions = () => {
  return (dispatch, getState) => {

    if (!('Notification' in window)) {
      alert('This browser does not support system notifications');
      return;
    }

    if (Notification.permission !== 'denied' || Notification.permission === 'default') {
      Promise.resolve(Notification.requestPermission()).then((permission) => {

      });
    }

  }
}

export default {
  addNewNotificationToAll,
  getUserUnreadNotifications,
  markNotificationAsSeen,
  subscribeToNotificationsSocket,
  markConsultationNotificationsRead,
  requestBrowserNotificationPermissions
}
